module.exports = __webpack_public_path__ + "static/media/groupe-seenergi.85c96892.png";